import valueFilters from '../valueFilters';
import modelFactory from '../modelFactory';

export interface IArrayItem {
	key?: string;
}

const arrayItemFactory = modelFactory.createFactory<IArrayItem>('ArrayItem', {
	key: {
		setFilters: valueFilters.clean
	},
	_fromDocument: function (val) {
		this.key = val.key || val;
	},
	_toDocument: function () {
		return this.key;
	}
});

export default arrayItemFactory;